/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".policy-second-container[_ngcontent-%COMP%]{top:3rem;right:0;width:16rem;z-index:1}.active_policy[_ngcontent-%COMP%]{background-color:#007ac9}\n/*# sourceMappingURL=desktop-selector.component.css.map*/"];
export { styles as styles };
